// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { put, call, takeEvery } from 'redux-saga/effects';

import { searchAddressService, selectedAddressService } from './service';
import * as addressSearchActions from './actions';
import * as types from './actionTypes';
import * as profileActions from '../../MyProfile/store/actions';

function* addressSearchSaga(payload) {
  const res = yield call(searchAddressService, payload.data);
  if (res.ok) {
    yield put(addressSearchActions.addressSearchRequestSuccess(res.body.results));
  } else {
    yield put(addressSearchActions.addressSearchRequestFailed());
  }
}

function* selectedAddressSaga(payload) {
  const res = yield call(selectedAddressService, payload.data);
  if (res.ok) {
    const address = res.body.result;
    yield put(addressSearchActions.requestSelectedAddressSuccess(res.body.result));
    if (address.postal_code) {
      yield put(profileActions.changeFieldAddress(address.postal_code, 'Postcode'));
    }
    if (address.line_1) {
      yield put(profileActions.changeFieldAddress(address.line_1, 'AddressLine1'));
    }
    if (address.line_2) {
      yield put(profileActions.changeFieldAddress(address.line_2, 'AddressLine2'));
    }
    if (address.locality) {
      yield put(profileActions.changeFieldAddress(address.locality, 'Town'));
    }
    if (address.province_name) {
      yield put(profileActions.changeFieldAddress(address.province_name, 'County'));
    }
  } else {
    yield put(addressSearchActions.requestSelectedAddressFailed());
  }
}

const searchAddressSagas = [
  takeEvery(types.ADDRESS_SEARCH_REQUEST, addressSearchSaga),
  takeEvery(types.SELECTED_ADDRESS_REQUEST, selectedAddressSaga),
];

export default searchAddressSagas;
